// extracted by mini-css-extract-plugin
export var core = "CarbonFreeAnimation-module--core--bf245";